import { render } from "./preset-events.vue?vue&type=template&id=68323994&lang=pug"
import script from "./preset-events.vue?vue&type=script&lang=js"
export * from "./preset-events.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__